/*  */

//*componentes-utiles
//*datos

//*clases

//*componente
    export default function PaginaMenu3() {
    return (
        <div className="container container-Vista" >
        <h1>Página menu 3</h1>
        <br></br>
        </div>
    );
    }
